import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, Icon, PreviewAltCard, Row } from "../../components/Component";
import { Button, Form } from "reactstrap";
import { useForm, useFieldArray } from "react-hook-form";

import {
  createFaqAPI,
  listFaqAPI,
  updateFaqAPI,
} from "../../api/master/indes";

import { toast } from "react-toastify";
import MyButton from "../../MyComp/UI/form/MyButton";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import useLogout from "../../hooks/useLogout";
import Table from "../../MyComp/UI/DataTable/Table";
import CKEditor from "../../MyComp/UI/CK Editor/index";

const WebFAQ = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      isPub: false,
      faqs: [{ question: "", answer: "" }],
      disease: [],
    },
  });

  const {
    fields: faqFields,
    append: addFaq,
    remove: removeFaq,
    replace
  } = useFieldArray({
    control,
    name: "faqs",
  });

  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const [data, setData] = useState([]);

  const isLoading = watch("isLoading");

  // ================= INIT =================
  useEffect(() => {
    getFaq();
  }, []);

  const getFaq = () => {
    setValue("isLoading", true);
    listFaqAPI()
      .then((res) => {
        if (res.data.status === true) {
          console.log(res);

          setData(res.data.data || []);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };


  // ================= SUBMIT =================
  const onFormSubmit = () => {
    const faqs = (watch("faqs") || []).map((faq, index) => {
      const answer =
        window?.CKEDITOR?.instances[`faq_answer_${index}`]?.getData() || "";
      return {
        question: faq.question,
        answer: answer.replace(/&nbsp;/g, " "),
      };
    });

    const body = {
      faqs,
      ...(mode === "Edit" && { id: watch("selectedRow")?.id }),
    };

    const apiCall =
      mode === "Add"
        ? createFaqAPI(body)
        : updateFaqAPI(body);

    setValue("isLoading", true);

    apiCall
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          getFaq();
          setIsOpen(false);
        } else if (res.data.status === "expired") {
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };


  const handleEdit = (row) => {
    console.log(row, "row");
    setValue("selectedRow", row);
    const faqsData = Array.isArray(row)
      ? row.map((faq) => ({
        id: faq?.id || "",
        question: faq?.question || "",
        answer: faq?.answer || "",
      }))
      : [
        {
          id: row?.id || "",
          question: row?.question || "",
          answer: row?.answer || "",
        },
      ];
    replace(faqsData);
    setTimeout(() => {
      faqsData.forEach((faq, index) => {
        const editor = window?.CKEDITOR?.instances?.[`faq_answer_${index}`];

        if (editor) {
          editor.setData(faq?.answer || "");
        }
      });
    }, 500);

    setMode("Edit");
    setIsOpen(true);
  };
  // ================= RESET =================
  const resetF = () => {
    setValue("faqs", [{ question: "", answer: "" }]);
    setMode("Add");
  };

  const faqData = Array.isArray(data)
    ? data
    : Object.values(data || {});

  const formattedData = faqData.map((item) => ({
    id: item?.id,
    question: item?.question || "No FAQs",
    answer: item?.answer || "No FAQs",
    status: item?.status,
  }));


  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow")?.id,
      status: updatedStatus,
    };
    updateFaqAPI(formObject)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getFaq()
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <Head title={"Web FAQ"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              {/* <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle> */}
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          {isOpen && (
            <PreviewAltCard className="mb-5" style={{ padding: "50px" }}>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                {/* ================= FAQ ================= */}
                <Row className="mt-4">
                  <Col md={12}>
                    <h5>FAQs</h5>
                    <Row className="mb-3">
                      {faqFields.map((item, index) => (
                        <>
                          <Col md="5">
                            <MyInput
                              key={item.id}
                              register={register}
                              name={`faqs.${index}.question`}
                              title="Question"
                              required
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              placeholder={"Enter Question"}
                              defaultValue={item.question}
                            />
                            <label>Answer</label>
                            <CKEditor id={`faq_answer_${index}`} />
                          </Col>

                          <Col md="1">
                            {faqFields.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => removeFaq(index)}
                              >
                                Remove
                              </button>
                            )}
                          </Col>

                        </>

                      ))}
                    </Row>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={() => addFaq({ question: "", answer: "" })}
                    >
                      + Add FAQ
                    </button>
                  </Col>
                </Row>

                {/* SUBMIT */}
                <Row className="mt-4">
                  <Col md="2">
                    <MyButton isLoading={isLoading} mode={mode} />
                  </Col>
                </Row>
              </Form>
            </PreviewAltCard>
          )}

          {/* TABLE */}
          <Table
            title=" FAQ List"
            data={formattedData}
            columns={[
              { key: "question", label: "Question" },
              { key: "answer", label: "Answer", },
            ]}
            nameColumn="question"
            onEditClick={handleEdit}
            toggleCanvas={() => setIsOpen(!isOpen)}
            resetF={resetF}
            statusFilterEnabled={true}
            handleToggleStatus={handleToggleStatus}
            confirmStatusChange={confirmStatusChange}
            addButton={false}
          />
        </Block>
      </Content>
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default WebFAQ;